import React, { PureComponent, memo } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faGlobeAmericas, faLongArrowAltRight, faSpinner } from '@fortawesome/free-solid-svg-icons';

import './LoginPage.css';
import { establecerUsuario, establecerUsuarioConectado } from '../../store/usuario/actions';
import { SiteRutas, ImagenesRutas } from '../../request/RutasConfig';
import { Notificacion } from '../../components/Util/Notificacion/Notificacion';
import { Login_Request, Login_Token_Request } from '../../request/LoginRequest';
import { Obtener_Estado_Active_Directory_Request } from '../../request/ParametroRequest';

class LoginPage extends PureComponent {
    _isMounted = false;
    state = {
        username: '',
        password: '',
        token_exists: false,
        activoAD: false,
        btnActivo: true
    }

    componentDidMount() {
        this._isMounted = true;
        sessionStorage.clear();

        if (location.search) {
            const urlParams = new URLSearchParams(location.search);
            if (urlParams.has('token') && urlParams.get('token')) {
                this.setState({ token_exists: true }, () => this.autenticar_usuario_token(urlParams.get('token')));
            }
        }
        this.obtenerEstadoActiveDirectory();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    obtenerEstadoActiveDirectory = async () => {
        const response = await Obtener_Estado_Active_Directory_Request();
        if (response.Exitoso) {
            this.setState({ activoAD: response.Datos });
        }
        else {
            Notificacion.error(response.Mensaje);
        }
    };

    autenticarUsuario = async () => {
        const { username, password } = this.state;

        const emp_id = this.props.empresa && this.props.empresa.Id ? this.props.empresa.Id : 0;
        const suc_id = this.props.sucursal && this.props.sucursal.Id ? this.props.sucursal.Id : 0;

        if (this.validarDatos(username, password)) {
            const response = await Login_Request(username, password, emp_id, suc_id);
            if (response.Exitoso) {
                if (response.Mensaje === "cambiar") {
                    Notificacion.error('Su contraseña ha vencido. Se redireccionará para que cambie su contraseña de ingreso.');
                    this.setDatosUsuario(response.Datos);
                    this.props.history.push(SiteRutas.CambiarContrasena);
                }
                else {
                    this._isMounted && this.setState({ username: '', password: '' });
                    Notificacion.success("Se ha iniciado sesión.");
                    this.setDatosUsuario(response.Datos);

                    if (!emp_id || !this.props.callCenter || !this.props.callCenter.Id) {
                        this.props.history.push(SiteRutas.Parametros);
                    }
                    else {
                        this.props.history.push(SiteRutas.Home);
                    }
                }
            }
            else {
                Notificacion.error(response.Mensaje);
            }
        }

        this.setState({ btnActivo: true });
    }

    autenticar_usuario_token = async (pToken) => {

        const emp_id = this.props.empresa && this.props.empresa.Id ? this.props.empresa.Id : 0;
        const suc_id = this.props.sucursal && this.props.sucursal.Id ? this.props.sucursal.Id : 0;

        const response = await Login_Token_Request(pToken, emp_id, suc_id);
        if (response.Exitoso) {

            Notificacion.success("Se ha iniciado sesión.");
            this.setDatosUsuario(response.Datos);

            if (!emp_id || !this.props.callCenter || !this.props.callCenter.Id) {
                this.props.history.push(SiteRutas.Parametros);
            }
            else {
                this.props.history.push(SiteRutas.Home);
            }
        }
        else {
            this.setState({ token_exists: false });
            Notificacion.error(response.Mensaje);
        }
    }

    validarDatos = () => {
        const { username, password } = this.state;

        if (!username || !username.trim()) {
            Notificacion.error("Por favor ingrese un usuario.");
            return false;
        }

        if (!password || !password.trim()) {
            Notificacion.error("Por favor ingrese la contraseña.");
            return false;
        }

        return true;
    }

    setDatosUsuario = (pUsuario) => {
        this.props.establecerUsuarioConectado(true);
        this.props.establecerUsuario({
            token: pUsuario.Token,
            nombre: pUsuario.Nombre,
            imagen_url: pUsuario.Imagen_Url,
            login: pUsuario.Login,
            activo_AD: pUsuario.AD_Activo
        });
    }

    onInputChanged = event => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    passwordOnKeyPressed = event => {
        if (this.state.btnActivo && (event.which === 13 || event.keyCode === 13)) {
            this.setState({ btnActivo: false }, () => {
                this.autenticarUsuario();
            });
        }
    }

    onClickBtnLogin = event => {
        event.preventDefault();
        if (this.state.btnActivo) {
            this.setState({ btnActivo: false }, () => {
                this.autenticarUsuario();
            });
        }
    }

    render() {
        const appVersion = document.getElementById('appVersion').value;

        const divStyle = {
            background: 'url(' + ImagenesRutas.Fondo_Login + ') no-repeat center center fixed',
            backgroundSize: 'cover'
        };

        return (
            <div style={divStyle} className="menu_container MainContainer">
                <div className="container overflow-auto">
                    <div className="pull-right">
                        <img className="logo_ld small" src={ImagenesRutas.Logo_LD_Blanco} alt="LogicalDataLogo" />
                    </div>
                    <div className="login_bg">
                        <p className="title">Express Web</p>
                        {
                            this.state.token_exists ?
                                <div className="row">
                                    <div className="col-12 text-center">
                                        <FontAwesomeIcon style={{ color: '#FFF' }} size="4x" icon={faSpinner} spin />
                                    </div>
                                </div>
                                :
                                <>
                                    <h1 className="h1 text-center">Inicio de Sesión</h1>
                                    {
                                        this.state.activoAD ?
                                            <div className="row">
                                                <div className="col-sm-12 text-center">
                                                    <p style={{ color: '#FFF' }}>Solo es permitido el ingreso al sistema mediante la aplicación de LD Login.</p>
                                                </div>
                                            </div>
                                            :
                                            <>
                                                <div className="row">
                                                    <div className="col-md-10 col-sm-12 offset-md-1">
                                                        <input type="text"
                                                            className="login"
                                                            name="username"
                                                            placeholder="Usuario"
                                                            onChange={this.onInputChanged}
                                                            value={this.state.username} />
                                                        <input type="password"
                                                            className="login"
                                                            name="password"
                                                            placeholder="Contraseña"
                                                            onChange={this.onInputChanged}
                                                            onKeyPress={this.passwordOnKeyPressed}
                                                            value={this.state.password} />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 text-center">
                                                        <button onClick={this.onClickBtnLogin} className="btn btn-iniciar" id="btn-iniciar" disabled={!this.state.btnActivo}> Iniciar Sesión {this.state.btnActivo ? <FontAwesomeIcon icon={faLongArrowAltRight} /> : <FontAwesomeIcon icon={faSpinner} spin />}</button>
                                                    </div>
                                                </div>
                                            </>
                                    }
                                </>
                        }
                        <hr className="hr" />
                    </div>
                    <div className="version">
                        <p> Desarrollado por: Logical Data, CR. Versión: {appVersion} | Todos los Derechos Reservados
                            |  Contáctenos: <FontAwesomeIcon icon={faGlobeAmericas} /> <a href="http://www.ld.co.cr/" title="">  http://www.ld.co.cr/ </a>
                            | <FontAwesomeIcon icon={faEnvelope} /> <a href="mailto:info@ld.co.cr">info@ld.co.cr</a>&nbsp;
                            | <i className="clip-phone-4"></i> +(506) 4052-2780</p>
                    </div>
                </div>
            </div>
        )
    }
};

const mapStateToProps = state => {
    return {
        empresa: state.parametros.empresa,
        sucursal: state.parametros.sucursal,
        callCenter: state.parametros.callCenter
    };
};

const mapDispatchToProps = {
    establecerUsuario,
    establecerUsuarioConectado
};

export default connect(mapStateToProps, mapDispatchToProps)(memo(LoginPage));